<template>
  <div style="width:100%;height: 100%;">
    <el-form style="width: 80%;margin:20px auto auto;" label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="合同编号：">
            <el-input v-model="parentData.contract_no" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="合同金额：">
            <el-input v-model="contractAmount" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="客户名称：">
            <el-input v-model="parentData['company_lib.name@company_id']" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="收款公司：">
            <el-input v-model="receiveCompanyName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="销售：">
            <el-input v-model="parentData['sys_user.full_name@sales_user_id']" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="提成方案：" required>
            <el-select v-model="finCommissionId" :disabled="isDisable">
              <el-option v-for="item in ruleList" :key="item.id" :label="item.name" :value="item.id" ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div style="margin-left: 20px;margin-top:10px;font-weight: bold">产品信息：</div>
    <div style="width: 80%;display: flex;line-height: 32px;margin-bottom: 10px">
      <div style="width: 25%;text-align: right">期数：</div>
      <div style="width: 25%;">
        <el-input v-model="parentData.phase" disabled></el-input>
      </div>
      <div style="width: 25%;text-align: right">本期金额：</div>
      <div style="width: 25%;"><el-input v-model="productPhasePrice" disabled></el-input></div>
    </div>
    <kf-input-table style="width: 99%" :form-readonly="true" ref="fin_product_detail"
                    component-id="fin_product_detail" v-model="productList"></kf-input-table>

    <div style="margin-left: 20px;margin-top:10px;font-weight: bold">收款信息：</div>
    <div style="width: 80%;display: flex;line-height: 32px;margin-bottom: 10px">
      <div style="width: 25%;text-align: right">期数：</div>
      <div style="width: 25%;">
        <el-input v-model="parentData.phase" disabled></el-input>
      </div>
      <div style="width: 25%;text-align: right">本期金额：</div>
      <div style="width: 25%;"><el-input v-model="paymentPhasePrice" disabled></el-input></div>
    </div>
    <kf-input-table style="width: 99%" :form-readonly="true" ref="fin_payment_detail"
                    component-id="fin_payment_detail" v-model="paymentList"></kf-input-table>

    <div style="margin-left: 20px;margin-top:10px;font-weight: bold">提成计算：</div>

    <div v-for="item in productList" :key="item.nanoid"
        style="margin-top: 20px;border: 1px solid #cccccc">
      <div style="width: 80%;display: flex;flex-wrap: wrap;line-height: 32px;margin-top: 10px">
      <div class="width25_align">产品名称：</div><el-input style="width: 75%;margin-bottom: 10px" v-model="item.product_name" disabled></el-input>
      <div class="width25_align">产品编码：</div><el-input class="width25" v-model="item.code" disabled></el-input>
      <div class="width25_align">授权方式：</div><el-input class="width25" v-model="item.authorize_type_name" disabled></el-input>
      <div class="width25_align">单位：</div><el-input class="width25" v-model="item.unit" disabled></el-input>
      <div class="width25_align">数量：</div><el-input class="width25" v-model="item.cnt" disabled></el-input>
      <div class="width25_align">总价：</div><el-input class="width25" v-model="item.total_price" disabled></el-input>
      <div class="width25_align">税率：</div><el-input class="width25" v-model="item.rate" disabled></el-input>
      <div class="width25_align">税额：</div><el-input class="width25" v-model="item.rate_price" disabled></el-input>
      <div class="width25_align">未税金额：</div><el-input class="width25" v-model="item.no_rate_price" disabled></el-input>

      <div class="width25_align">提成类型：</div>
      <div class="width25">
        <el-select v-model="item.finCommissionType" @change="commissionTypeChange(item)" :disabled="isDisable">
          <el-option label="不计提成" value="no_commission" key="no_commission"></el-option>
          <el-option label="SW产品" value="sw_product" key="sw_product"></el-option>
          <el-option label="技术服务" value="technology_service" key="technology_service"></el-option>
          <el-option label="其他软件" value="other_software" key="other_software"></el-option>
          <el-option label="维护服务" value="maintenance_service" key="maintenance_service"></el-option>
          <el-option label="SS维护" value="ss_maintenance" key="ss_maintenance"></el-option>
        </el-select>
      </div>
      <div v-if="item.showBusinessType" class="width25_align">业务类型：</div>
      <div v-if="item.showBusinessType" class="width25">
        <el-select v-model="item.finBusinessType" @change="otherCalculateCommissionData(item)" :disabled="isDisable">
          <el-option v-for="businessItem in item.businessList" :key="businessItem.nanoid" :label="businessItem.name" :value="businessItem.nanoid" ></el-option>
        </el-select>
      </div>

      <div v-if="item.finCommissionType === 'sw_product'"
           style="width: 100%;display: flex;flex-wrap: wrap;line-height: 32px">
        <div style="width:100%;margin-left: 20px;margin-top:10px;font-weight: bold">业务费用、组网、培训、实施费用、税费扣除：</div>
        <div class="width25_align">扣除金额：</div><el-input class="width25" v-model="item.otherFees" @change="calculateCommissionAmount()" :disabled="isDisable" ></el-input>
        <div class="width25_align">计算提成金额：</div><el-input class="width25" v-model="item.commissionAmount" disabled></el-input>

        <div style="width:100%;margin-left: 20px;margin-top:10px;font-weight: bold">产品折扣提成：</div>
        <div class="width25_align">折扣：</div><el-input class="width25" v-model="item.showProductDiscount" disabled></el-input>
        <div class="width25_align">提成比例：</div><el-input class="width25" v-model="item.showProductCommissionRatio"  disabled></el-input>

        <div style="width:100%;margin-left: 20px;margin-top:10px;font-weight: bold">新客户额外提成：</div>
        <div class="width25_align">是否新客户：</div><el-input class="width25" v-model="item.showIsNewCustomer" disabled></el-input>
        <div class="width25_align">客户类型：</div><el-input class="width25" v-model="item.showCustomerType" disabled></el-input>
        <div class="width25_align">额外提成比例：</div><el-input class="width25" v-model="item.showLcCommission"  disabled></el-input>

        <div style="width:100%;margin-left: 20px;margin-top:10px;font-weight: bold">反盗版老客户提成扣除：</div>
        <div class="width25_align">是否反盗版老客户：</div><el-input class="width25" v-model="item.showIsLcOldCustomer" disabled></el-input>
        <div class="width25_align">U-leads：</div><el-input class="width25" v-model="item.showIsLcULeads" disabled></el-input>
        <div class="width25_align">T-leads：</div><el-input class="width25" v-model="item.showIsLcTLeads" disabled></el-input>
        <div class="width25_align">扣除比例：</div><el-input class="width25" v-model="item.showLcDeductCommission" disabled></el-input>

        <div style="width:100%;margin-left: 20px;margin-top:10px;font-weight: bold">RAID客户提成：</div>
        <div class="width25_align">是否RAID客户：</div><el-input class="width25"  disabled></el-input>

        <div style="width:100%;margin-left: 20px;margin-top:10px;font-weight: bold">本项提成：</div>
        <div class="width25_align">本项提成比例：</div><el-input class="width25" v-model="item.finalCommission" disabled></el-input>
        <div class="width25_align">本项提成金额：</div><el-input class="width25" v-model="item.finalCommissionAmount" disabled></el-input>
      </div>

      <div v-if="item.finCommissionType === 'technology_service'" style="width: 100%;display: flex;flex-wrap: wrap;line-height: 32px;">
        <div style="width:100%;margin-left: 20px;margin-top:10px;font-weight: bold">技术服务业务提成：</div>
        <div class="width25_align">保底提成比例：</div><el-input class="width25" v-model="item.showTechnologyServiceRatio" disabled></el-input>
        <div style="width:100%;margin-left: 20px;margin-top:10px;font-weight: bold">本项提成：</div>
        <div class="width25_align">本项提成比例：</div><el-input class="width25" v-model="item.finalCommission" disabled></el-input>
        <div class="width25_align">本项提成金额：</div><el-input class="width25" v-model="item.finalCommissionAmount" disabled></el-input>
      </div>

      <div v-if="item.finCommissionType === 'other_software'" style="width: 100%;display: flex;flex-wrap: wrap;line-height: 32px;">
        <div style="width:100%;margin-left: 20px;margin-top:10px;font-weight: bold">其它软件提成：</div>
        <div class="width25_align">保底提成比例：</div><el-input class="width25" v-model="item.showOtherSoftwareRatio" disabled></el-input>
        <div style="width:100%;margin-left: 20px;margin-top:10px;font-weight: bold">本项提成：</div>
        <div class="width25_align">本项提成比例：</div><el-input class="width25" v-model="item.finalCommission" disabled></el-input>
        <div class="width25_align">本项提成金额：</div><el-input class="width25" v-model="item.finalCommissionAmount" disabled></el-input>
      </div>

      <div v-if="item.finCommissionType === 'maintenance_service'" style="width: 100%;display: flex;flex-wrap: wrap;line-height: 32px;">
        <div style="width:100%;margin-left: 20px;margin-top:10px;font-weight: bold">维护服务提成：</div>
        <div class="width25_align">提成比例：</div><el-input class="width25" v-model="item.showMaintenanceServiceRatio" disabled></el-input>
        <div style="width:100%;margin-left: 20px;margin-top:10px;font-weight: bold">本项提成：</div>
        <div class="width25_align">本项提成比例：</div><el-input class="width25" v-model="item.finalCommission" disabled></el-input>
        <div class="width25_align">本项提成金额：</div><el-input class="width25" v-model="item.finalCommissionAmount" disabled></el-input>
      </div>

      <div v-if="item.finCommissionType === 'ss_maintenance'" style="width: 100%;display: flex;flex-wrap: wrap;line-height: 32px;">
        <div style="width:100%;margin-left: 20px;margin-top:10px;font-weight: bold">SS维护服务提成：</div>
        <div class="width25_align">提成比例：</div><el-input class="width25" v-model="item.showMaintenanceRatio" disabled></el-input>
        <div style="width:100%;margin-left: 20px;margin-top:10px;font-weight: bold">SS维护提成分配比例：</div>
        <div class="width25_align">销售：</div><el-input class="width25" v-model="item.showSalesMaintenanceRatio" disabled></el-input>
        <div class="width25_align">SS专员：</div><el-input class="width25" v-model="item.showSsMaintenanceRatio" disabled></el-input>
        <div style="width:100%;margin-left: 20px;margin-top:10px;font-weight: bold">Recapture部分提成：</div>
        <div class="width25_align">Recapture提成：</div><el-input class="width25" v-model="item.showSsRecaptureRatio" disabled></el-input>
      </div>
      </div>
    </div>

    <div style="margin-left: 20px;margin-top:10px;font-weight: bold">合计提成：</div>
    <div style="width: 80%;display: flex;flex-wrap: wrap;line-height: 32px;margin-bottom: 10px">
      <div style="width: 25%;text-align: right">销售：</div>
      <div style="width: 25%;">
        <el-input v-model="parentData['sys_user.full_name@sales_user_id']" disabled></el-input>
      </div>
      <div class="width25_align">合计提成金额：</div>
      <div class="width25"><el-input v-model="salesCommissionSumAmount" disabled></el-input></div>

      <div class="width25_align">SS专员：</div>
      <div class="width25"><el-input  disabled></el-input></div>

      <div class="width25_align">合计提成金额：</div>
      <div class="width25"><el-input v-model="ssCommissionSumAmount" disabled></el-input></div>
    </div>

    <div style="margin-left: 20px;margin-top:10px;font-weight: bold">回款超期提成扣除比例：</div>
    <div style="width: 80%;display: flex;line-height: 32px;margin-bottom: 10px">
      <div class="width25_align">延期天数：</div>
      <div class="width25">
        <el-input v-model="delayDays" disabled></el-input>
      </div>
      <div class="width25_align">提成扣除比例：</div>
      <div class="width25"><el-input v-model="delayDayDeductionRatio" disabled></el-input></div>
    </div>

    <div style="margin-left: 20px;margin-top:10px;font-weight: bold">应发放提成金额：</div>
    <div style="width: 80%;display: flex;flex-wrap: wrap;line-height: 32px;margin-bottom: 10px">
      <div class="width25_align">销售：</div>
      <div class="width25">
        <el-input v-model="parentData['sys_user.full_name@sales_user_id']" disabled></el-input>
      </div>
      <div class="width25_align">合计提成金额：</div>
      <div class="width25"><el-input v-model="salesCommissionSumAmount" disabled></el-input></div>
      <div class="width25_align">SS专员：</div>
      <div class="width25">
        <el-input v-model="parentData['sys_user.full_name@ss_commissioner_id']" disabled></el-input>
      </div>
      <div class="width25_align">合计提成金额：</div>
      <div class="width25"><el-input v-model="ssCommissionSumAmount" disabled></el-input></div>
    </div>

    <div v-if="parentData.status === 'wait_grant' || parentData.status === 'issued' " style="margin-left: 20px;margin-top:10px;font-weight: bold">发放结果：</div>
    <div v-if="parentData.status === 'wait_grant' || parentData.status === 'issued' " style="width: 80%;display: flex;flex-wrap: wrap;line-height: 32px;margin-bottom: 10px">
      <div class="width25_align">发放结果：</div>
      <div class="width25">
        <el-input v-model="commissionGrantResult" readonly disabled></el-input>
      </div>
      <div class="width25_align">发放日期：</div>
      <div class="width25"><el-date-picker v-model="commissionGrantDate" :disabled="isDisable"></el-date-picker></div>
      <div class="width25_align">备注：</div>
      <div style="width:75%;margin-bottom: 10px;">
        <el-input type="textarea" rows="3" v-model="commissionGrantRemark" :disabled="isDisable"></el-input>
      </div>
    </div>

    <div style="width: 100%;margin-top: 10px;margin-bottom: 20px;text-align: center">
      <el-button v-if="parentData.status === 'wait_calculate'" type="primary" @click="saveData" style="width: 100px">确认</el-button>
      <el-button v-if="parentData.status === 'wait_grant'" type="primary" @click="saveGrantData" style="width: 100px">确认</el-button>
    </div>

  </div>

</template>

<script>
export default {
  name: "CommissionCalculation",
  inject: ['$fn'],

  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      productList: [],
      paymentList:[],
      contractAmount:0,
      receiveCompanyName:'',
      ruleList:[],
      productPhasePrice:0,
      paymentPhasePrice:0,
      finCommissionId:'',
      delayDays:0,
      delayDayDeductionRatio:0.0,
      salesCommissionSumAmount:0.0,
      ssCommissionSumAmount:0.0,
      commissionGrantResult:'已发放',
      commissionGrantDate:'',
      commissionGrantRemark:'',
      isDisable:false,

    }
  },
  async created() {
    await this.initData();
  },

  methods: {
    async initData(){
      await this.getAllData();
      if(this.parentData.status === 'wait_grant'){
        this.isDisable = true;
        await this.getSaveData();
      }
      if(this.parentData.status === 'issued'){
        this.isDisable = true;
        await this.getSaveData();
        this.commissionGrantDate = this.parentData.commission_grant_date;
        this.commissionGrantRemark = this.parentData.commission_grant_remark;
      }

    },
    //获取本页所需的所有数据
    async getAllData(){
      let params = {
        contract_no:this.parentData.contract_no,
        chance_id:this.parentData.chance_id,
        phase:this.parentData.phase,
      }
      let data = await this.$http('financeService.getCommissionData',params);
      this.contractAmount = data.total_amount;
      this.receiveCompanyName = data.receive_company_name;
      this.ruleList = data.rule_list;
      this.productPhasePrice = data.product_phase_price;
      this.paymentPhasePrice = data.phase_price;
      this.productList = data.product_list;
      this.paymentList = data.payment_list;
    },
    async getSaveData(){
      let data = await this.$http('financeService.getSaveCommissionData',{id:this.parentData.id});
      let content = JSON.parse(data.content);
      this.productList = content.productList;
      this.paymentList = content.paymentList;
      this.finCommissionId = content.finCommissionId;
      this.salesCommissionSumAmount = content.salesCommissionSumAmount;
      this.ssCommissionSumAmount = content.ssCommissionSumAmount;
      this.delayDays = content.delayDays;
      this.delayDayDeductionRatio = content.delayDayDeductionRatio;

    },

    async saveData(){
      //校验
      if(!this.finCommissionId){
        this.$message.error('请选择提成规则');
        return;
      }

      let params = {
        finCommissionId:this.finCommissionId,
        contractAmount:this.contractAmount,
        receiveCompanyName:this.receiveCompanyName,
        id:this.parentData.id,
        productList: this.productList,
        paymentList: this.paymentList,
        delayDays: this.delayDays,
        delayDayDeductionRatio: this.delayDayDeductionRatio,
        salesCommissionSumAmount:this.salesCommissionSumAmount,
        ssCommissionSumAmount:this.ssCommissionSumAmount,
      }
      await this.$http('financeService.saveCommissionData',params);
      this.$message.success("保存成功");
      this.$fn.search();
      this.$fn.closeWindow();
    },

    async saveGrantData(){
      let params = {
        id:this.parentData.id,
        commissionGrantResult:this.commissionGrantResult,
        commissionGrantDate:this.commissionGrantDate,
        commissionGrantRemark:this.commissionGrantRemark,
      }
      await this.$http('financeService.saveGrantCommissionData',params);
      this.$fn.search();
      this.$message.success("保存成功");
      this.$fn.closeWindow();
    },

    async commissionTypeChange(product){
      if(product.finCommissionType === 'no_commission' || product.finCommissionType === 'sw_product'
          || product.finCommissionType === 'maintenance_service' || product.finCommissionType === 'ss_maintenance'){
        product.showBusinessType = false;
        //计算提成数据
        await this.calculateCommissionData(product);
      }
      product.finBusinessType = '';
      if(!this.finCommissionId){
        this.$message.error("请先选择提成方案");
        return;
      }
      let params = {
        finCommissionType: product.finCommissionType,
        finCommissionId: this.finCommissionId,
      }
      let data = await this.$http('financeService.getFinBusinessType',params);
      product.showBusinessType = data.showBusinessType;
      product.businessList = data.businessList;

      await this.calculateCommissionAmount();
    },
    async calculateCommissionData(product){
      let obj = {
        chance_id:this.parentData.chance_id,
        product:product,
        finCommissionId:this.finCommissionId,
      }
      let data = {};
      //计算SW产品数据
      if(product.finCommissionType === 'sw_product'){
        data = await this.$http('financeService.getSwProductData',obj);
      }
      //计算维护服务的提成数据
      if(product.finCommissionType === 'maintenance_service'){
        data = await this.$http('financeService.getMaintenanceServiceData',obj);
      }

      //计算SS维护提成数据
      if(product.finCommissionType === 'ss_maintenance'){
        data = await this.$http('financeService.getSsMaintenanceData',obj);
      }
      for (let productItem of this.productList){
        if(productItem.nanoid === data.nanoid){
          Object.assign(productItem, data);
        }
      }
      await this.calculateDelayDays();
    },
    async otherCalculateCommissionData(product){
      let finBusinessTypeName = '';
      for (let item of product.businessList){
        if(item.nanoid === product.finBusinessType){
          finBusinessTypeName = item.name;
          break;
        }
      }
      let obj = {
        chance_id:this.parentData.chance_id,
        product:product,
        finCommissionId:this.finCommissionId,
        finBusinessType:finBusinessTypeName,
      }
      let data = {};
      //计算技术服务数据
      if(product.finCommissionType === 'technology_service'){
        data = await this.$http('financeService.getTechnologyServiceData',obj);
      }
      //计算其他软件提成数据
      if(product.finCommissionType === 'other_software'){
        data = await this.$http('financeService.getOtherSoftwareData',obj);
      }
      for (let productItem of this.productList){
        if(productItem.nanoid === data.nanoid){
          Object.assign(productItem, data);
        }
      }
      await this.calculateDelayDays();
      await this.calculateCommissionAmount();
    },

    //计算延期天数，按最大的延期天数算，并计算扣除比例
    async calculateDelayDays(){
      let delayDays = 0;
      for (let payItem of this.paymentList){
        if(delayDays === 0){
          delayDays = payItem.delay_day;
        }else {
          if(delayDays < payItem.delay_day){
            delayDays = payItem.delay_day;
          }
        }
      }
      this.delayDays = delayDays;
      let params = {
        commissionId: this.finCommissionId,
        delayDay: delayDays,
      }
      let data = await this.$http('financeService.getDelayDayDeductionRatio',params);
      this.delayDayDeductionRatio = data.delayDayDeductionRatio;
    },

    //计算提成费用
    async calculateCommissionAmount(){
      for (let productItem of this.productList) {
        let cnt = productItem.cnt;
        let noRatePrice = productItem.no_rate_price;
        //SW产品
        if (productItem.finCommissionType === 'sw_product') {
          if (!productItem.otherFees) {
            productItem.otherFees = 0;
          }
          let profit = noRatePrice - productItem.otherFees - (productItem.cost * cnt);
          let showProductCommissionRatio = productItem.showProductCommissionRatio || 0;
          let showLcCommission = productItem.showLcCommission || 0;
          let showLcDeductCommission = productItem.showLcDeductCommission || 0;
          let finallyCommission = showProductCommissionRatio + showLcCommission - showLcDeductCommission;
          //本项的提成比例
          productItem.finalCommission = finallyCommission;
          //本项的提成金额 = 本项的利润 * 提成比例
          productItem.finalCommissionAmount = Math.round(profit * 0.01 * finallyCommission).toFixed(2);
          //计算提成金额
          productItem.commissionAmount = Math.round(profit * 0.01 * finallyCommission).toFixed(2);
        }
        //维护服务
        if (productItem.finCommissionType === 'maintenance_service') {
          let profit = noRatePrice - (productItem.cost * cnt);

          let finallyCommission = productItem.showMaintenanceServiceRatio;
          //本项的提成比例
          productItem.finalCommission = finallyCommission;
          //本项的提成金额 = 本项的利润 * 提成比例
          productItem.finalCommissionAmount = Math.round(profit * 0.01 * finallyCommission).toFixed(2);
        }
        //SS维护
        if (productItem.finCommissionType === 'ss_maintenance') {
          let profit = noRatePrice - (productItem.cost * cnt);

          let finallyCommission = productItem.showMaintenanceRatio + productItem.showSsRecaptureRatio;
          //本项的提成金额 = 本项的利润 * 提成比例
          let ssRatio = parseFloat(productItem.showSalesMaintenanceRatio) * 0.01;
          let salesRatio = parseFloat(productItem.showSsMaintenanceRatio) * 0.01;
          productItem.finalCommissionAmount = Math.round(profit * 0.01 * finallyCommission * ssRatio).toFixed(2);
          productItem.finalSSCommissionAmount = Math.round(profit * 0.01 * finallyCommission * salesRatio).toFixed(2);
        }
        //技术服务
        if (productItem.finCommissionType === 'technology_service') {
          let profit = noRatePrice - (productItem.cost * cnt);

          let finallyCommission = productItem.showTechnologyServiceRatio;
          //本项的提成比例
          productItem.finalCommission = finallyCommission;
          //本项的提成金额 = 本项的利润 * 提成比例
          productItem.finalCommissionAmount = Math.round(profit * 0.01 * finallyCommission).toFixed(2);
        }
        //其他软件
        if (productItem.finCommissionType === 'other_software') {
          let profit = noRatePrice - (productItem.cost * cnt);

          let finallyCommission = productItem.showOtherSoftwareRatio;
          //本项的提成比例
          productItem.finalCommission = finallyCommission;
          //本项的提成金额 = 本项的利润 * 提成比例
          productItem.finalCommissionAmount = Math.round(profit * 0.01 * finallyCommission).toFixed(2);
        }
      }
      await this.calculateTotalAmount();
    },

    //计算总金额
    async calculateTotalAmount(){
      let salesTotalAmount = 0;
      let ssTotalAmount = 0;
      for (let productItem of this.productList) {
        if(productItem.finalCommissionAmount){
          salesTotalAmount = salesTotalAmount + parseFloat(productItem.finalCommissionAmount);
        }
        if(productItem.finalSSCommissionAmount){
          ssTotalAmount = ssTotalAmount + parseFloat(productItem.finalSSCommissionAmount);
        }
      }
      this.salesCommissionSumAmount = salesTotalAmount;
      this.ssCommissionSumAmount = ssTotalAmount;
    },

  }
}
</script>

<style scoped>

.width25_align{
  width: 25%;
  text-align: right;
  margin-bottom: 10px;
}
.width25{
  width: 25%;
  margin-bottom: 10px;
}

</style>